import { EZModule } from "../../classes/v2/EZModule";

export default class ToTop extends EZModule {
    private static supportPageOffset = window.pageXOffset !== undefined; // used in the query of 'scrollTop'
    private static isCSS1Compat = ((document.compatMode || "") === "CSS1Compat"); // making sure the html is in full standard mode (it is when <!DOCTYPE html> is at the very beginning of a html site, e.g. it's not when there is a XML declaration above)
    private static toTopDOMElement: HTMLLinkElement; // the toTop html element
    private static config:any; // ToTop yaml part

    /** @param configuration = part of the yaml with ToTop */
    constructor(configuration: any) {
        super(configuration);
        ToTop.config = configuration; // ToTop yaml part
    }

    public init(): void {
        ToTop.toTopDOMElement = document.getElementById('to_top') as HTMLLinkElement; // getting the dom element
        if ( ToTop.toTopDOMElement)
        {
            ToTop.toTopDOMElement.innerHTML = ToTop.config.components.foundation.structure; // filling the a dom via yaml
            this.checkDifference(); // initial check for displaying the button
            window.addEventListener('scroll', ()=> { this.checkDifference() }); // on windows scroll event
            ToTop.toTopDOMElement.addEventListener('click', this.goToTopEventListener); // on click event
        }
    }

    public run() {} // empty. Kept for compability.

    /**
     * Returns the class name of the root element.
     * @returns The class name of the HTML element that houses the NavHelper
     */
    public getClass(): string {
        return "ez-totop";
    }

    /**
     * @description checking whether the current users height is at the very top or not
     * dis-/enabling the button depending on the height
     */
    private checkDifference():void {
        let scrollTop = ToTop.supportPageOffset ? window.pageYOffset : ToTop.isCSS1Compat ? document.documentElement.scrollTop : document.body.scrollTop; // making sure to cover multiple browsers, since the do not all have the same functionality
        if (scrollTop > 0) { // when the current position is not at the very top, showing the button
            ToTop.toTopDOMElement.classList.add('ezShowToTop');
        }
        else { // hiding the button
            if ( ToTop.toTopDOMElement.classList.contains('ezShowToTop') ) ToTop.toTopDOMElement.classList.remove('ezShowToTop');
        }
    }

    /** @description adding a click event to the toTopDOMElement button */
    private goToTopEventListener():void {
        // let scrollLeft = supportPageOffset ? window.pageXOffset : isCSS1Compat ? document.documentElement.scrollLeft : document.body.scrollLeft;
        let scrollTop = ToTop.supportPageOffset ? window.pageYOffset : ToTop.isCSS1Compat ? document.documentElement.scrollTop : document.body.scrollTop; // making sure to cover multiple browsers, since the do not all have the same functionality
        if (scrollTop > 0) {
            switch (true) { // making sure older browsers can handle this too
                case (window.scrollTo !== undefined):
                    window.scrollTo({ top: 0, behavior: 'smooth' }); break;
                case (window.scroll !== undefined):
                    window.scroll({ top: 0, behavior: 'smooth' }); break;
                default:
                    document.body.scrollTop = 0; break; // oldest variation I found
            }
        }
    }
}